import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const EditIcon = props => {
  return (
    <Svg
      width={26}
      height={26}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.607 4.221a1 1 0 01-.129 1.257L13.222 17.735a1 1 0 01-.454.26L7.662 19.33a1 1 0 01-1.22-1.22l1.333-5.105c.04-.15.113-.3.215-.416L20.293.293a1 1 0 011.414 0l3.771 3.771c.05.049.092.102.129.157zm-2.25.55L21 2.414 9.643 13.772l-.834 3.19L12 16.13 23.358 4.77z"
        fill="#3876AA"
      />
      <Path
        d="M23.189 19.88c.364-3.116.48-6.255.348-9.386a.536.536 0 01.156-.401l1.31-1.312a.265.265 0 01.453.17c.246 3.719.152 7.455-.281 11.162-.315 2.697-2.481 4.81-5.164 5.11-4.622.516-9.4.516-14.022 0-2.683-.3-4.848-2.413-5.164-5.11a61.229 61.229 0 010-14.226c.316-2.696 2.481-4.81 5.164-5.11A63.666 63.666 0 0116.641.494c.229.013.333.29.171.451L15.489 2.27a.536.536 0 01-.398.156c-2.968-.1-5.957.013-8.88.34-1.773.198-3.194 1.598-3.4 3.355a59.229 59.229 0 000 13.76c.206 1.757 1.627 3.157 3.4 3.355 4.475.5 9.104.5 13.578 0 1.773-.198 3.194-1.598 3.4-3.355z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default EditIcon;
